import { Button, Checkbox, useModal } from "@newsela/angelou";
import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";

import { useSearchAdminPermissions } from "@/search/NewSearchPageMVP/provider/hooks";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { FilterSection } from "@/search/NewSearchPageMVP/shared/FilterSection";
import { TaxonomyTags, useTaxonomyTagsContext } from "./TaxonomyTags";
import { TopicsDataQASelector } from "./Topics.constants";
import {
  checkboxCss,
  listContainerCss,
  listItemCss,
  topicsContainerCss,
  viewAllButtonCss,
} from "./Topics.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);
const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

const eventPropertiesViewAll = {
  objectType: "User",
  actionName: "Interact",
  event_type: "click",
  streamProperties: {
    component_type: "TopicsViewAll",
    description: "Open Taxonomy Modal",
  },
} as const;

export const Topics = () => {
  const [modalProps, setActive, triggerRef] = useModal();
  const { top5Ela, toggleSelection, isChecked, setShouldUpdateTags } =
    useTaxonomyTagsContext();
  const { blockActionAndShowConfirmationModal, blockFilterChanges } =
    useSearchAdminPermissions();
  const {
    getters: { isSearchLoading },
  } = useSearchPageContext();

  const handleChange = (id: string) => {
    if (blockFilterChanges) {
      blockActionAndShowConfirmationModal();
      return;
    }

    toggleSelection(id);
    setShouldUpdateTags(true);
  };

  if (!top5Ela.length) {
    return null;
  }

  return (
    <>
      <FilterSection title="Topics">
        <div css={topicsContainerCss}>
          <ul css={listContainerCss}>
            {top5Ela?.map((topic) => (
              <li key={topic.slug} css={listItemCss}>
                <CheckboxWithTrackEvent
                  __cssFor={checkboxCss}
                  label={topic.label}
                  value={topic.value}
                  checked={isChecked(topic.value, true)}
                  onChange={() => handleChange(topic.value)}
                  objectType={objectTypes.content}
                  actionName={actionNames.filter}
                  streamProperties={{
                    description: "Select topic for search query",
                  }}
                  dataProps={{
                    "data-qa-selector": TopicsDataQASelector.SELECT_TOPIC,
                    "data-testid": `checkbox-${topic.value}`,
                  }}
                  disabled={isSearchLoading}
                />
              </li>
            ))}
          </ul>
          <ButtonWithTrackEvent
            {...eventPropertiesViewAll}
            size={Button.sizes.sm}
            __cssFor={viewAllButtonCss}
            flavor={Button.flavors.tertiary}
            onClick={() => setActive(true)}
            ref={triggerRef}
            dataProps={{
              "data-qa-selector": TopicsDataQASelector.VIEW_ALL,
              "data-testid": "view-all-button",
            }}
          >
            View all
          </ButtonWithTrackEvent>
        </div>
      </FilterSection>
      <TaxonomyTags modalProps={modalProps} setActive={setActive} />
    </>
  );
};
